import { useMemo, useState } from 'react';
import { Link } from 'react-router-dom';
import { cases } from '@/mocks/cases';
import SectionHeading from '@/components/base/SectionHeading';
import { getNodeStyle } from '@/lib/caseMeta';

const filters = ['全部', '反转', '回应', '辟谣', '爆料'];

const allNodes = cases
  .flatMap((item) =>
    item.timeline.map((node) => ({
      ...node,
      caseId: item.id,
      caseTitle: item.title,
      category: item.category,
    })),
  )
  .sort((a, b) => (a.date < b.date ? 1 : -1));

const TimelineSection = () => {
  const [active, setActive] = useState('全部');

  const nodes = useMemo(
    () => (active === '全部' ? allNodes : allNodes.filter((n) => n.type === active)).slice(0, 7),
    [active],
  );

  return (
    <section id="timeline" className="scroll-mt-24 border-b border-background-200 bg-background-50">
      <div className="layout-shell py-12 md:py-16">
        <div className="flex flex-col gap-6 lg:flex-row lg:items-end lg:justify-between">
          <SectionHeading
            eyebrow="Live Timeline"
            title="最新时间线"
            desc="把所有事件的关键节点汇总成一条时间线，按发生时间由近到远排列。"
          />
          <div className="flex flex-wrap gap-2" role="tablist" aria-label="按节点类型筛选时间线">
            {filters.map((f) => (
              <button
                key={f}
                type="button"
                role="tab"
                aria-selected={active === f}
                onClick={() => setActive(f)}
                className={`whitespace-nowrap rounded-full border px-3.5 py-1.5 text-xs font-medium transition-colors ${
                  active === f
                    ? 'border-primary-500 bg-primary-500 text-background-50'
                    : 'border-background-300 bg-background-50 text-foreground-700 hover:border-primary-300'
                }`}
              >
                {f}
              </button>
            ))}
          </div>
        </div>

        <ol className="mt-8 relative border-l border-background-300 pl-6 md:pl-8">
          {nodes.map((node, index) => {
            const style = getNodeStyle(node.type);
            return (
              <li key={`${node.caseId}-${index}`} className="relative pb-8 last:pb-0">
                <span
                  className={`absolute -left-[31px] top-1.5 flex h-4 w-4 items-center justify-center rounded-full ring-4 ring-background-50 md:-left-[39px] ${style.dot}`}
                  aria-hidden="true"
                />
                <div className="rounded-lg border border-background-300/70 bg-background-100 p-4 md:p-5">
                  <div className="flex flex-wrap items-center gap-2">
                    <span className={`inline-flex items-center rounded-full border px-2.5 py-0.5 text-xs font-medium ${style.chip}`}>
                      {node.type}
                    </span>
                    <span className="text-xs text-foreground-500">{node.date}</span>
                    <span className="text-xs text-foreground-500">· {node.category}</span>
                  </div>
                  <h3 className="mt-2.5 font-heading text-base font-bold leading-snug text-foreground-950">{node.title}</h3>
                  <p className="mt-2 text-sm leading-relaxed text-foreground-600">{node.desc}</p>
                  <Link
                    to={`/case/${node.caseId}`}
                    className="mt-3 inline-flex items-center gap-1.5 text-xs font-medium text-primary-700 transition-colors hover:text-primary-800"
                  >
                    <i className="ri-bookmark-line" aria-hidden="true" />
                    {node.caseTitle}
                  </Link>
                </div>
              </li>
            );
          })}
          {nodes.length === 0 && (
            <li className="pb-2 text-sm text-foreground-500">该类型暂无节点，试试切换其他筛选。</li>
          )}
        </ol>
      </div>
    </section>
  );
};

export default TimelineSection;